"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
//VARIABLE MODELS
const data_source_1 = require("./data-source");
let DataSourceService = class DataSourceService {
    constructor(_http, _talk) {
        this._http = _http;
        this._talk = _talk;
        //declarations
        this.dataSources = [];
        this.currentSource = new data_source_1.DataSource({});
        this.BIDDR = 'biddr';
        this.RTBX = 'rtbx';
        this.DEALS = 'deals';
        this.CONNECT = 'connect';
        //initializations
        this.dataSourceURL = "/datasource";
    }
    pull() {
        return this._http.get(this.dataSourceURL)
            .toPromise()
            .then(response => {
            const sources = JSON.parse(response._body);
            this.dataSources = this.initDataSources(sources);
        })
            .catch(this._talk.handle);
    }
    get() {
        let dataSources = JSON.parse(JSON.stringify(this.dataSources));
        return dataSources.map(dataSource => { return new data_source_1.DataSource(dataSource); });
    }
    getSource(sourceSlug) {
        const matchingDataSource = this.dataSources.find(dataSource => dataSource.slug === sourceSlug);
        if (matchingDataSource)
            return matchingDataSource;
        console.warn(`Invalid data source ${sourceSlug} given.`);
        return new data_source_1.DataSource();
    }
    getDashboardDisplaySource() {
        return this.get().filter(dataSource => dataSource.dashboardEnabled);
    }
    getCurrentSource() {
        if (this.currentSource.slug)
            return this.currentSource;
        else if (this.dataSources && this.dataSources.length)
            return new data_source_1.DataSource(this.dataSources[0]);
        else
            return new data_source_1.DataSource();
    }
    setCurrentSource(source) {
        this.currentSource = new data_source_1.DataSource(source);
    }
    setMetricsVisibility(dataMetrics) {
        if (dataMetrics && dataMetrics.length) {
            for (let metric of dataMetrics) {
                // for now hide sum_bid //All Bids
                metric.visible = (metric.slug === 'sum_bid') ? false : true;
            }
        }
        return dataMetrics;
    }
    initDataSources(sources) {
        if (sources && sources.length) {
            for (let source of sources) {
                source = new data_source_1.DataSource(source);
                this.setMetricsVisibility(source.dataMetrics);
            }
        }
        return sources;
    }
    getMetrics(source) {
        return this.dataSources.find(ds => ds.slug == source).dataMetrics;
    }
    isServerSide(sourceSlug) {
        return (sourceSlug || '').includes(this.RTBX);
    }
    isClientSide(sourceSlug) {
        return (sourceSlug || '').includes(this.BIDDR);
    }
    isDeals(sourceSlug) {
        return (sourceSlug || '').includes(this.DEALS);
    }
    isConnect(sourceSlug) {
        return (sourceSlug || '').includes(this.CONNECT);
    }
    isServerSideOrDealsOrConnect(slug) {
        return (this.isServerSide(slug) || this.isDeals(slug) || this.isConnect(slug));
    }
};
exports.DataSourceService = DataSourceService;
exports.DataSourceService = DataSourceService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService])
], DataSourceService);
//# sourceMappingURL=data-source.service.js.map